import { Button } from '@design-system';
import { ShieldOff, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import type { PilotCapability } from '@shared';
import { useActivePilotProgram } from '@/shared/hooks/use-active-pilot-program';

interface PilotBlockedPageProps {
  capability: PilotCapability;
  clientId?: string;
}

export function PilotBlockedPage({ capability, clientId }: PilotBlockedPageProps) {
  const navigate = useNavigate();
  const program = useActivePilotProgram();
  const copy = program?.blockedPages?.[capability];

  const handleBack = () => {
    if (clientId) {
      navigate(`/clients/${clientId}/onboarding/funding-sources`);
    } else {
      navigate(-1);
    }
  };

  if (!copy) {
    return null;
  }

  return (
    <div className="bg-background flex min-h-screen items-center justify-center px-4">
      <div className="max-w-md text-center">
        <div className="bg-muted mx-auto mb-6 flex size-16 items-center justify-center rounded-full">
          <ShieldOff className="text-foreground size-8" />
        </div>
        <h1 className="text-balance text-xl font-semibold text-gray-950">{copy.heading}</h1>
        <p className="text-foreground mt-3 text-balance">{copy.body}</p>
        <div className="mt-8">
          <Button
            variant="outline"
            onClick={handleBack}
          >
            <ArrowLeft className="size-4" />
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
}
